var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 42",
    d: "M4.85355 0.146447C4.65829 -0.0488148 4.34171 -0.0488148 4.14645 0.146447L0.964466 3.32843C0.769204 3.52369 0.769204 3.84027 0.964466 4.03553C1.15973 4.2308 1.47631 4.2308 1.67157 4.03553L4.5 1.20711L7.32843 4.03553C7.52369 4.2308 7.84027 4.2308 8.03553 4.03553C8.2308 3.84027 8.2308 3.52369 8.03553 3.32843L4.85355 0.146447ZM5 13.5L5 0.5H4L4 13.5H5Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c82e8be591150c55395ad422d1c7f15a.svg";
export { ForwardRef as ReactComponent };